import React, { useState } from "react";
import axios from "../../api";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Alert,
  InputAdornment,
  IconButton,
  Box,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { toast } from "react-toastify";

const PASSWORD_HINT = "At least 8 characters with a letter and a number.";

function ForcePasswordChangeDialog({ open, userId, onComplete }) {
  const [oldPassword, setOldPassword] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [show, setShow] = useState(false);
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 8) {
      setError("Password must be at least 8 characters.");
      return;
    }
    if (!/[A-Za-z]/.test(password) || !/[0-9]/.test(password)) {
      setError("Password must include at least one letter and one number.");
      return;
    }
    if (password !== confirm) {
      setError("Passwords do not match.");
      return;
    }
    setSaving(true);
    try {
      await axios.put(`/users/changePassword/${userId}`, {
        oldPassword,
        password,
      });
      localStorage.removeItem("requirePasswordChange");
      toast.success("Password updated");
      onComplete?.();
    } catch (err) {
      setError(err.response?.data?.message || "Could not change password");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} maxWidth="xs" fullWidth disableEscapeKeyDown>
      <DialogTitle>Change your password</DialogTitle>
      <DialogContent>
        <Alert severity="warning" sx={{ mb: 2 }}>
          Your administrator requires you to set a new password before continuing.
        </Alert>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        <Box component="form" id="force-pw-form" onSubmit={handleSubmit}>
          <TextField
            fullWidth
            margin="dense"
            label="Current password"
            type={show ? "text" : "password"}
            value={oldPassword}
            onChange={(e) => setOldPassword(e.target.value)}
            required
          />
          <TextField
            fullWidth
            margin="dense"
            label="New password"
            type={show ? "text" : "password"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            helperText={PASSWORD_HINT}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShow((v) => !v)} edge="end" size="small">
                    {show ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <TextField
            fullWidth
            margin="dense"
            label="Confirm new password"
            type={show ? "text" : "password"}
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            required
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button type="submit" form="force-pw-form" variant="contained" disabled={saving}>
          {saving ? "Saving…" : "Update password"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ForcePasswordChangeDialog;
